import { render, staticRenderFns } from "./OrientacoesLista.vue?vue&type=template&id=8852d080"
import script from "./OrientacoesLista.vue?vue&type=script&lang=js"
export * from "./OrientacoesLista.vue?vue&type=script&lang=js"
import style0 from "./OrientacoesLista.vue?vue&type=style&index=0&id=8852d080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular})
